
import { Component, Vue, Prop } from 'vue-property-decorator'

import { CompanyType, CompanyTypeText } from '@/utils/enums'
import { Company } from '@/types/Company'
import authModule from '@/store/auth'
import companyModule from '@/store/company'
import whitelabelModule from '@/store/whitelabel'
import { TextFieldRules } from '@/utils/enums'
import { compareNested } from '@/utils/utility-manager'
import axios from 'axios'

@Component({
  name: 'CompanyEditor'
})
class CompanyEditor extends Vue {
  @Prop() readonly edit?: boolean
  private rules = TextFieldRules

  private categories: any[] = []
  private form: Partial<Company> = {
    name: '',
    legalName: '',
    description: '',
    type: [],
    category: [],
    url: '',
    email: '',
    emailPublic: false,
    phone: '',
    facebook: '',
    instagram: '',
    whatsapp: '',
    active: true,
    address: {
      street: '',
      streetNo: '',
      zipCode: undefined,
      city: '',
      countryCode: '',
      location: undefined
    }
  }

  private get auth() {
    return authModule
  }

  private get company(): Company | undefined {
    return companyModule.company
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private get whitelabels() {
    return whitelabelModule.whitelabels
  }

  private get companyTypes() {
    return companyModule.companyTypes
  }

  private get filteredCategories() {
    if (
      this.form.type!.includes(CompanyType.LOCAL) &&
      this.form.type!.includes(CompanyType.ONLINE)
    ) {
      return this.categories
    }
    if (this.form.type!.includes(CompanyType.LOCAL)) {
      return this.categories.filter(el => el.type === CompanyType.LOCAL)
    }
    if (this.form.type!.includes(CompanyType.ONLINE)) {
      return this.categories.filter(el => el.type === CompanyType.ONLINE)
    }
    return []
  }

  private async created(): Promise<void> {
    const { data } = await axios.get(
      `/admin/${this.whitelabel.slug}/category/list`
    )
    this.categories = data.categories

    if (!this.edit) return
    if (!this.company) {
      await companyModule.fetch(this.$route.params.cid)
    }

    this.form = JSON.parse(JSON.stringify(this.company))
  }

  private async saveCompany(): Promise<void> {
    if (!this.edit) {
      companyModule.create({
        whitelabel: this.whitelabel._id,
        company: this.form
      })
    } else {
      const updatedCompany: Partial<Company> = await compareNested(
        this.form,
        this.company
      )
      Object.assign(updatedCompany, { _id: this.company!._id })

      const payload = {
        whitelabel: this.company!.whitelabel,
        company: updatedCompany
      }
      companyModule.update(payload)
    }
    document.dispatchEvent(new Event('close-company'))
  }
}

export default CompanyEditor
